import { cva, type VariantProps } from 'class-variance-authority';
import type { HTMLAttributes } from 'vue';
import type { RouteLocationRaw } from 'vue-router';

export { default as LinkList } from './LinkList.vue';

export interface LinkListItem {
	name: string;
	image?: string;
	route?: RouteLocationRaw;
	links: { label: string; route: RouteLocationRaw }[];
}

export interface LinkListProps {
	title?: string;
	links: LinkListItem[];
	variant?: LinkListVariants['variant'];
	class?: HTMLAttributes['class'];
	titleClass?: HTMLAttributes['class'];
	imageWrapperClass?: HTMLAttributes['class'];
	imageClass?: HTMLAttributes['class'];
	itemTitleClass?: HTMLAttributes['class'];
	linkClass?: HTMLAttributes['class'];
	linkListClass?: HTMLAttributes['class'];
	linkCategoryClass?: HTMLAttributes['class'];
}

export const linkListVariant = cva('', {
	variants: {
		variant: {
			image: 'space-y-6',
			'no-image': 'space-y-6'
		}
	},
	defaultVariants: {
		variant: 'image'
	}
});

export type LinkListVariants = VariantProps<typeof linkListVariant>;

export const imageWrapperVariant = cva(
	'flex w-full cursor-pointer flex-col gap-3 md:flex-row md:gap-6',
	{
		variants: {
			variant: {
				image: '',
				'no-image': 'hidden'
			}
		},
		defaultVariants: {
			variant: 'image'
		}
	}
);

export type ImageWrapperVariants = VariantProps<typeof imageWrapperVariant>;

export const itemTitleVariant = cva(
	'font-matter-sq font-normal leading-normal',
	{
		variants: {
			variant: {
				image: 'absolute text-2xl tracking-[-0.4px] text-white',
				'no-image': 'text-[22px] tracking-[-0.48px] text-primary md:text-2xl'
			}
		},
		defaultVariants: {
			variant: 'image'
		}
	}
);

export type ItemTitleVariants = VariantProps<typeof itemTitleVariant>;

export type LinkClickedWithCategory = LinkListItem['links'][number] & {
	category: LinkListItem['name'];
};
